import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";

interface Props {
  readonly value: number | null;
  readonly minYear?: number;
  readonly maxYear?: number;
  readonly onChange: (year: number | null) => void;
}

const YearPicker: FC<Props> = ({ value, minYear, maxYear, onChange }) => {
  const handleChange = (newValue: Dayjs | null) => {
    const newYearValue = newValue?.format("YYYY") ?? null;
    onChange(newYearValue ? Number.parseInt(newYearValue) : null);
  };

  const minDate = minYear
    ? dayjs(`${minYear}-01-01`, ISO_DATE_FORMAT).startOf("year")
    : dayjs("2018-01-01", ISO_DATE_FORMAT);
  const maxDate = maxYear ? dayjs(`${maxYear}-01-01`, ISO_DATE_FORMAT).endOf("year") : dayjs().add(3, "years");
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar
        views={["year"]}
        openTo="year"
        minDate={minDate}
        maxDate={maxDate}
        value={value ? dayjs(`${value}`, "YYYY") : undefined}
        onChange={handleChange}
      />
    </LocalizationProvider>
  );
};

export default YearPicker;
